import React from 'react';
import ModuleEditOptionsSection from "../ModuleEditOptionsSection";
import IrradienceCharts
    from "../../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/IrradienceCharts";

const ChartsTabIpad: React.FC = () => {
    return (
        <div className='tab__inner'>
            <ModuleEditOptionsSection/>
            <div className='tab__column'>
                <IrradienceCharts/>
            </div>
        </div>
    );
}

export default ChartsTabIpad;